// Các hộp mở từ nút trên thẻ bot (màn hình chính gộp, 05/10/2026): "đang chạy" (chip), Lịch sử, Nhóm, Lệnh. Mỗi hộp: mở một lần (bấm hai lần
// không mở thêm), Esc / bấm nền / Đóng / đổi trang đều đóng; lỗi máy chủ hiện rõ trong hộp kèm nút Thử lại, không treo ở "Đang tải…".
// Chữ do máy chủ/bot trả (tên bot, tên nhóm, lý do) luôn qua textContent (h()) — không bao giờ innerHTML.
import { api, buildQuery, errMsg } from "../api";
import { busy, clear, confirmBox, h, toast } from "../dom";
import { chuanHoaGhiChu, demKyTu, GHI_CHU_TOI_DA } from "../../../../src/shared/ghi-chu-bot";
import { bangTangTruong, duongNho, type TruongSoLieu } from "../../../../src/shared/so-lieu-kenh";
interface MangSoLieuWeb { nenTang: string; taiKhoan: string; diem: { luc: string; chiSo: Partial<Record<TruongSoLieu, number>> }[] }
import { fmtAgo, fmtTime, modeTagClass, modeText, runNhanHien } from "../format";
import { khongDau, tinhTrangBot } from "../logic-man-hinh";
import { store } from "../store";
import { MSG_DANG_DOC } from "../../../../src/shared/nhom-nick";
import { conDangDocNhom, ghiDaRaLenhDocLai } from "../doc-lai-nhom";
import { ganLyDo, ganTenKbChu, layTenBuoc, tenKb, tenKbDaBiet } from "../ten-kb";
import type { Bot, Job, JobSpec, PreviewResult, RunSummary, TongQuanBot } from "../types";
import { moHopChonKichBan } from "./chon-kich-ban";
import { LOW_CONFIDENCE, previewSentence, type DraftResult } from "./lenh";

/** Số lần chạy gần nhất hiện trong hộp Lịch sử. */
export const SO_LAN_LICH_SU = 10;
/** Số nhóm vẽ tối đa một lần trong hộp Nhóm (lọc để thấy nhóm còn lại). */
export const SO_NHOM_TOI_DA = 300;
const MAX_LENH = 5000; // khớp MAX_TEXT của máy chủ (draft.ts)

export interface Hop { wrap: HTMLElement; than: HTMLElement; chan: HTMLElement; dong: () => void }

/** Dựng hộp chung. Trả null nếu hộp cùng mã đã mở (bấm hai lần không mở hai hộp). Dùng chung cho hộp Sao lưu plugin (bot-sao-luu.ts). */
export function moHop(tieuDe: string, testid: string, lop = ""): Hop | null {
  if (document.querySelector(`[data-testid="${testid}"]`)) return null;
  const than = h("div", { class: "bot-hop-than" });
  const chan = h("div", { class: "row end bot-hop-chan" });
  let phim: (e: KeyboardEvent) => void = () => {};
  const dong = (): void => { document.removeEventListener("keydown", phim, true); wrap.remove(); };
  const nutX = h("button", { type: "button", class: "kb-noi-x", "aria-label": "Đóng hộp", title: "Đóng hộp này", "data-testid": `${testid}-x`, onclick: dong }, "×");
  const wrap = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "aria-label": tieuDe, "data-testid": testid },
    h("div", { class: `modal bot-hop ${lop}`.trim() }, h("div", { class: "row between bot-hop-dau" }, h("h3", {}, tieuDe), nutX), than, chan));
  phim = (e: KeyboardEvent): void => {
    if (e.key !== "Escape") return;
    const tren = [...document.querySelectorAll<HTMLElement>(".modal-wrap")].pop();
    if (tren === wrap) { e.preventDefault(); e.stopPropagation(); dong(); }
  };
  const moLuc = Date.now(); // bấm đúp nút mở hộp: cú bấm thứ hai rơi vào nền hộp mới hiện — không được đóng hộp
  wrap.addEventListener("click", (e) => { if (e.target === wrap && Date.now() - moLuc > 400) dong(); });
  wrap.addEventListener("dong-hop", () => document.removeEventListener("keydown", phim, true)); // đổi trang / Esc toàn cục (dongHopTrang)
  document.addEventListener("keydown", phim, true);
  document.body.appendChild(wrap);
  return { wrap, than, chan, dong };
}
const nutDong = (hop: Hop): HTMLButtonElement => h("button", { type: "button", title: "Đóng hộp này", "data-testid": "bot-hop-dong", onclick: hop.dong }, "Đóng");

/** Dừng việc đang chạy của bot: nằm trong chuỗi → dừng chuỗi trên bot này; chạy lẻ → dừng lần chạy. Ném lỗi máy chủ để nơi gọi hiện rõ. */
export async function dungBot(b: Bot, tq: TongQuanBot | undefined): Promise<string> {
  const c = tq?.chuoi;
  if (c) {
    await api("POST", `/api/chuoi/${encodeURIComponent(c.id)}/dung`, { botId: b.id });
    return `Đã dừng chuỗi “${c.ten}” trên ${b.name}`;
  }
  if (b.current) {
    await api("POST", `/api/runs/${encodeURIComponent(b.current.runKey)}/stop`);
    return `Đã gửi lệnh dừng tới ${b.name}`;
  }
  throw new Error("Bot không có việc nào đang chạy để dừng");
}
export const coViecDeDung = (b: Bot, tq: TongQuanBot | undefined): boolean => b.online && !!(tq?.chuoi || b.current);

// ------------------------------------------------------------------ "đang chạy" (chip)
export function hopChip(b: Bot, tq: TongQuanBot | undefined, khiDoi: () => void): void {
  const hop0 = moHop(`Đang chạy trên ${b.name}`, "bot-chip-hop");
  if (!hop0) return;
  const hop: Hop = hop0;
  const tt = tinhTrangBot(b, tq, undefined);
  hop.than.append(h("p", { "data-testid": "chip-tinh-trang" }, h("b", {}, "Tình trạng: "), tt.chu));
  const c = tq?.chuoi;
  if (c) {
    const tong = c.tongBuoc > 0 ? `/${c.tongBuoc}` : "";
    hop.than.append(h("div", { class: "bot-hop-khoi", "data-testid": "chip-chuoi" },
      h("div", {}, h("b", {}, "Chuỗi kịch bản: "), h("span", { class: "wrap" }, c.ten)),
      h("div", { class: "small muted" }, `Đang ở bước ${Math.min(c.buocHienTai + 1, c.tongBuoc || c.buocHienTai + 1)}${tong}${c.trangThai === "nghi" ? " (đang nghỉ giữa hai kịch bản)" : c.trangThai === "cho_bot" ? " (chờ bot trực tuyến)" : ""}`),
      h("a", { class: "btn mini", href: `#/chuoi/${encodeURIComponent(c.id)}`, title: "Mở chuỗi này: thứ tự kịch bản, bot, tiến độ từng bước", "data-testid": "chip-mo-chuoi" }, "Mở chuỗi")));
    if (tq && tq.soChuoi > 1) hop.than.append(h("p", { class: "small muted" }, `Bot còn nằm trong ${tq.soChuoi - 1} chuỗi khác đang chạy.`));
  }
  if (b.current) {
    const cur = b.current;
    const tenBuocEl = h("span", { class: "wrap" }, cur.stepId ? "…" : "(chưa rõ)");
    if (cur.stepId) layTenBuoc(cur.bundleName, (tra) => { tenBuocEl.textContent = tra(cur.stepId!); });
    hop.than.append(h("div", { class: "bot-hop-khoi", "data-testid": "chip-kich-ban" },
      h("div", {}, h("b", {}, "Kịch bản: "), tenKb(cur.bundleName, { lienKet: true })),
      h("div", { class: "small" }, h("span", { class: "muted" }, "Bước: "), tenBuocEl),
      h("a", { class: "btn mini", href: `#/runs/${encodeURIComponent(cur.runKey)}`, title: "Mở chi tiết lần chạy này: nhật ký từng bước, dừng, duyệt", "data-testid": "chip-mo-lan-chay" }, "Xem lần chạy")));
  }
  if (!c && !b.current) hop.than.append(h("p", { class: "muted", "data-testid": "chip-ranh" }, "Bot đang rảnh — không có kịch bản hay chuỗi nào đang chạy."));
  const loi = h("div", { class: "err-box", hidden: true, "data-testid": "chip-loi" });
  hop.than.append(loi);

  const dangChay = coViecDeDung(b, tq);
  const dung = h("button", { type: "button", class: "danger", disabled: !dangChay, title: dangChay ? "Dừng việc đang chạy trên bot này (chuỗi thì dừng cả chuỗi trên bot này)" : "Bot không có việc nào đang chạy để dừng", "data-testid": "bot-chip-dung" }, "Dừng");
  const doi = h("button", { type: "button", class: "pri", disabled: !b.online, title: !b.online ? "Bot ngoại tuyến — không chạy được" : dangChay ? "Dừng việc đang chạy rồi chọn kịch bản khác để chạy trên bot này" : "Chọn kịch bản để chạy trên bot này (chưa chạy gì cho tới khi bạn bấm ▶ Chạy)", "data-testid": "bot-chip-doi" }, dangChay ? "Đổi kịch bản" : "Chạy kịch bản…");
  dung.addEventListener("click", () => void busy(dung, "Đang dừng…", async () => {
    loi.hidden = true;
    try { toast(await dungBot(b, tq)); hop.dong(); khiDoi(); } catch (e) { loi.textContent = errMsg(e); loi.hidden = false; }
  }));
  doi.addEventListener("click", () => void busy(doi, "Đang dừng…", async () => {
    loi.hidden = true;
    if (dangChay) {
      try { toast(await dungBot(b, tq)); } catch (e) { loi.textContent = errMsg(e); loi.hidden = false; return; }
    }
    hop.dong();
    khiDoi();
    moHopChonKichBan([b.id]);
  }));
  hop.chan.append(dung, doi, nutDong(hop));
}

// ------------------------------------------------------------------ Lịch sử
export function hopLichSu(b: Bot): void {
  const hop0 = moHop(`Lịch sử chạy — ${b.name}`, "bot-ls-hop");
  if (!hop0) return;
  const hop: Hop = hop0;
  const ds = h("div", { class: "bot-ls-ds", "data-testid": "bot-ls-ds" });
  hop.than.append(h("p", { class: "small muted" }, `${SO_LAN_LICH_SU} lần chạy gần nhất của bot này: giờ, kịch bản, chế độ, kết quả.`), ds);
  hop.chan.append(h("a", { class: "btn", href: `#/history?botId=${encodeURIComponent(b.id)}`, title: "Mở Lịch sử chạy đã lọc theo bot này để xem tất cả các lần chạy", "data-testid": "bot-ls-tat-ca" }, "Xem tất cả"), nutDong(hop));
  let luot = 0;
  async function tai(): Promise<void> {
    const g = ++luot;
    clear(ds);
    ds.append(h("p", { class: "muted", "data-testid": "bot-ls-dang-tai" }, "Đang tải…"));
    let items: RunSummary[];
    try {
      items = (await api<{ items: RunSummary[] }>("GET", `/api/runs${buildQuery({ botId: b.id, limit: SO_LAN_LICH_SU })}`)).items.slice(0, SO_LAN_LICH_SU);
    } catch (e) {
      if (g !== luot || !hop.wrap.isConnected) return;
      clear(ds);
      ds.append(h("div", { class: "err-box", "data-testid": "bot-ls-loi" }, `Không tải được lịch sử: ${errMsg(e)} `, h("button", { type: "button", class: "mini", title: "Tải lại lịch sử chạy của bot này", "data-testid": "bot-ls-thu-lai", onclick: () => void tai() }, "Thử lại")));
      return;
    }
    if (g !== luot || !hop.wrap.isConnected) return;
    clear(ds);
    if (!items.length) { ds.append(h("p", { class: "muted", "data-testid": "bot-ls-trong" }, "Bot này chưa chạy lần nào.")); return; }
    for (const r of items) {
      const nhan = runNhanHien(r);
      const ly = h("div", { class: "small muted wrap bot-ls-ly", "data-testid": "bot-ls-ly-do", hidden: !r.reason });
      if (r.reason) ganLyDo(ly, r.bundleName, r.reason);
      ds.append(h("div", { class: "bot-ls-dong", "data-testid": "bot-ls-dong", dataset: { runKey: r.key } },
        h("div", { class: "row small" },
          h("span", { class: "muted nowrap", "data-testid": "bot-ls-gio" }, fmtTime(r.startedAt ?? r.plannedAt) || "chưa bắt đầu"),
          h("span", { class: modeTagClass(r.mode), "data-testid": "bot-ls-che-do" }, modeText(r.mode)),
          h("span", { class: `tag ${nhan.kind === "muted" ? "" : nhan.kind}`.trim(), "data-testid": "bot-ls-ket-qua" }, nhan.text)),
        h("div", { class: "wrap bot-ls-ten" }, h("a", { href: `#/runs/${encodeURIComponent(r.key)}`, title: "Mở chi tiết lần chạy này" }, tenKb(r.bundleName))),
        ly));
    }
  }
  void tai();
}

// ------------------------------------------------------------------ Số liệu kênh (07/10/2026, nhóm 3 thao tác xây kênh)
// Điểm do thao tác "Đọc số liệu kênh" (doc_so_lieu_kenh) gửi về qua run.final (server/src/so-lieu-kenh.ts). Mỗi mạng một bảng: chỉ số, hiện tại, thay đổi so
// với lần đọc cũ nhất trong 90 lần gần đây (+%), đường nhỏ xu hướng. Chữ do bot gửi (tên tài khoản) chỉ qua textContent.
const TEN_MANG_SL: Record<string, string> = { youtube: "YouTube", tiktok: "TikTok", facebook: "Facebook", x: "X", reddit: "Reddit" };
const SVG_NS = "http://www.w3.org/2000/svg";
const fmtSo = (n: number): string => n.toLocaleString("vi-VN");
function duongXuHuong(diem: number[], nhan: string): Element {
  if (diem.length < 2) return h("span", { class: "muted", title: "Mới có một lần đọc — chưa có xu hướng" }, "—");
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", "0 0 80 24");
  svg.setAttribute("width", "80");
  svg.setAttribute("height", "24");
  svg.setAttribute("role", "img");
  svg.setAttribute("class", "sl-duong");
  svg.setAttribute("aria-label", `Xu hướng ${nhan}: từ ${fmtSo(diem[0]!)} đến ${fmtSo(diem[diem.length - 1]!)} qua ${diem.length} lần đọc`);
  const pl = document.createElementNS(SVG_NS, "polyline");
  pl.setAttribute("points", duongNho(diem, 78, 20));
  pl.setAttribute("transform", "translate(1 2)");
  svg.append(pl);
  return svg;
}
export function hopSoLieu(b: Bot): void {
  const hop0 = moHop(`Số liệu kênh — ${b.name}`, "bot-so-lieu-hop", "so-lieu-hop");
  if (!hop0) return;
  const hop: Hop = hop0;
  const ds = h("div", { class: "so-lieu-ds", "data-testid": "sl-ds" });
  hop.than.append(h("p", { class: "small muted" }, "Số liệu do thao tác “Đọc số liệu kênh” đọc từ trang của chính nick trên bot này (chỉ đọc). Mỗi lần chạy thêm một lần đọc; cột Thay đổi so lần đọc mới nhất với lần cũ nhất trong 90 lần gần đây."), ds);
  hop.chan.append(nutDong(hop));
  let luot = 0;
  async function tai(): Promise<void> {
    const g = ++luot;
    clear(ds);
    ds.append(h("p", { class: "muted", "data-testid": "sl-dang-tai" }, "Đang tải…"));
    let mang: MangSoLieuWeb[];
    try {
      mang = (await api<{ mang: MangSoLieuWeb[] }>("GET", `/api/bots/${encodeURIComponent(b.id)}/so-lieu-kenh`)).mang;
    } catch (e) {
      if (g !== luot || !hop.wrap.isConnected) return;
      clear(ds);
      ds.append(h("div", { class: "err-box", "data-testid": "sl-loi" }, `Không tải được số liệu kênh: ${errMsg(e)} `, h("button", { type: "button", class: "mini", title: "Tải lại số liệu kênh của bot này", "data-testid": "sl-thu-lai", onclick: () => void tai() }, "Thử lại")));
      return;
    }
    if (g !== luot || !hop.wrap.isConnected) return;
    clear(ds);
    if (!mang.length) {
      ds.append(h("p", { class: "muted", "data-testid": "sl-trong" }, "Chưa có số liệu kênh nào. Thêm thao tác “Đọc số liệu kênh” vào một kịch bản (mạng nào cũng được) rồi chạy trên bot này — mỗi lần chạy thêm một lần đọc."));
      return;
    }
    for (const m of mang) {
      const bang = bangTangTruong(m.diem);
      const dau = m.diem[0]?.luc, cuoi = m.diem[m.diem.length - 1]?.luc;
      const than = h("tbody", {});
      for (const d of bang) {
        const huong = d.thayDoi === null ? "" : d.thayDoi > 0 ? "sl-tang" : d.thayDoi < 0 ? "sl-giam" : "sl-ngang";
        const thayDoi = d.thayDoi === null ? "—" : `${d.thayDoi > 0 ? "+" : ""}${fmtSo(d.thayDoi)}${d.phanTram === null ? "" : ` (${d.phanTram > 0 ? "+" : ""}${d.phanTram.toLocaleString("vi-VN")}%)`}`;
        than.append(h("tr", { "data-testid": "sl-dong", dataset: { truong: d.truong } },
          h("td", { class: "sl-nhan" }, d.nhan),
          h("td", { class: "num sl-so", "data-testid": "sl-hien-tai" }, fmtSo(d.moiNhat)),
          h("td", { class: `num sl-so ${huong}`.trim(), "data-testid": "sl-thay-doi", title: d.thayDoi === null ? "Mới có một lần đọc chỉ số này — chưa so được" : `Từ ${fmtSo(d.dauKy)} (lần đọc cũ nhất) đến ${fmtSo(d.moiNhat)}` }, thayDoi),
          h("td", { class: "sl-xu-huong" }, duongXuHuong(d.diem, d.nhan))));
      }
      ds.append(h("section", { class: "so-lieu-mang", "data-testid": "sl-mang", dataset: { nenTang: m.nenTang } },
        h("h4", { class: "sl-tieu-de" }, TEN_MANG_SL[m.nenTang] ?? m.nenTang, m.taiKhoan ? h("span", { class: "muted sl-tai-khoan", "data-testid": "sl-tai-khoan" }, ` · ${m.taiKhoan}`) : null),
        h("p", { class: "small muted", "data-testid": "sl-cap-nhat" }, `Lần đọc gần nhất: ${fmtTime(cuoi)} (${fmtAgo(cuoi)}) · ${m.diem.length} lần đọc${m.diem.length > 1 ? ` từ ${fmtTime(dau)}` : ""}`),
        h("div", { class: "so-lieu-cuon" }, h("table", { class: "so-lieu-bang" },
          h("thead", {}, h("tr", {}, h("th", {}, "Chỉ số"), h("th", { class: "num" }, "Hiện tại"), h("th", { class: "num" }, "Thay đổi"), h("th", {}, "Xu hướng"))),
          than))));
    }
  }
  void tai();
}

// ------------------------------------------------------------------ Nhóm đã tham gia
interface NhomView { nick: { botId: string; nickId: string; nickTen: string; capNhat: string }[]; nhom: { botId: string; nickId: string; url: string; ten: string; trangThai: string }[] }
export function hopNhom(b: Bot): void {
  const hop0 = moHop(`Nhóm của ${b.name}`, "bot-nhom-hop");
  if (!hop0) return;
  const hop: Hop = hop0;
  const tomTat = h("p", { "data-testid": "bot-nhom-tom-tat" }, "Đang tải…");
  const loc = h("input", { type: "search", placeholder: "Lọc theo tên nhóm…", "aria-label": "Lọc nhóm theo tên", autocomplete: "off", maxlength: 120, title: "Gõ một phần tên nhóm (gõ không dấu cũng được)", "data-testid": "bot-nhom-loc", hidden: true });
  const ds = h("div", { class: "bot-nhom-ds", "data-testid": "bot-nhom-ds" });
  const loi = h("div", { class: "err-box", hidden: true, "data-testid": "bot-nhom-loi" });
  hop.than.append(tomTat, loc, ds, loi);
  const docLai = h("button", { type: "button", disabled: !b.online, title: b.online ? "Ra lệnh cho bot đọc lại trang “Nhóm của bạn” trên Facebook (mất vài phút); mở lại hộp này sau đó" : "Bot ngoại tuyến — không đọc lại được", "data-testid": "bot-nhom-doc-lai" }, "Đọc lại");
  hop.chan.append(h("a", { class: "btn", href: "#/nhom-nick", title: "Mở trang Nhóm của nick: mọi nhóm, mọi trạng thái, mọi nick", "data-testid": "bot-nhom-trang" }, "Mở trang Nhóm"), docLai, nutDong(hop));
  let dsNhom: { url: string; ten: string; nick: string }[] = [];
  let tongVao = 0;
  const ve = (): void => {
    const q = khongDau(loc.value.trim());
    const khop = q ? dsNhom.filter((n) => khongDau(n.ten).includes(q)) : dsNhom;
    clear(ds);
    if (!khop.length) { if (dsNhom.length) ds.append(h("p", { class: "muted small", "data-testid": "bot-nhom-khong-khop" }, "Không có nhóm nào khớp.")); return; }
    for (const n of khop.slice(0, SO_NHOM_TOI_DA)) {
      const an = /^https?:\/\//i.test(n.url);
      ds.append(h("div", { class: "bot-nhom-dong wrap", "data-testid": "bot-nhom-dong" },
        an ? h("a", { href: n.url, target: "_blank", rel: "noopener noreferrer", title: "Mở nhóm trong tab mới" }, n.ten || n.url) : h("span", {}, n.ten || n.url),
        n.nick ? h("span", { class: "small muted" }, ` · ${n.nick}`) : null));
    }
    if (khop.length > SO_NHOM_TOI_DA) ds.append(h("p", { class: "small muted" }, `…và ${khop.length - SO_NHOM_TOI_DA} nhóm nữa — gõ vào ô lọc để thu hẹp.`));
  };
  loc.addEventListener("input", ve);
  async function tai(): Promise<void> {
    loi.hidden = true;
    let r: NhomView;
    try { r = await api<NhomView>("GET", `/api/nhom-nick${buildQuery({ botId: b.id })}`); }
    catch (e) {
      if (!hop.wrap.isConnected) return;
      tomTat.textContent = "";
      loi.textContent = `Không tải được danh sách nhóm: ${errMsg(e)}`;
      loi.hidden = false;
      loi.append(" ", h("button", { type: "button", class: "mini", title: "Tải lại danh sách nhóm", "data-testid": "bot-nhom-thu-lai", onclick: () => void tai() }, "Thử lại"));
      return;
    }
    if (!hop.wrap.isConnected) return;
    const tenNick = new Map(r.nick.map((n) => [n.nickId, n.nickTen]));
    const vao = (r.nhom ?? []).filter((n) => n.trangThai === "da_tham_gia" && (!n.botId || n.botId === b.id));
    dsNhom = vao.map((n) => ({ url: n.url, ten: n.ten, nick: r.nick.length > 1 ? tenNick.get(n.nickId) ?? "" : "" }));
    tongVao = dsNhom.length;
    const capNhat = r.nick.map((n) => n.capNhat).filter(Boolean).sort().pop() ?? null;
    tomTat.className = "";
    if (!r.nick.length) {
      tomTat.className = "warn";
      tomTat.textContent = "Chưa đọc được nhóm của bot này. Bấm Đọc lại để bot đọc danh sách nhóm trên Facebook.";
    } else if (!tongVao) {
      tomTat.className = "warn";
      tomTat.textContent = `Bot đã đọc nhóm ${fmtAgo(capNhat)} nhưng chưa thấy nhóm nào đã tham gia. Bấm Đọc lại nếu bot vừa vào nhóm.`;
    } else {
      const cu = capNhat ? Date.now() - Date.parse(capNhat) > 7 * 86_400_000 : false;
      tomTat.textContent = `Đã tham gia ${tongVao} nhóm · đọc lần cuối ${fmtAgo(capNhat)}${cu ? " (dữ liệu đã cũ — nên Đọc lại)" : ""}`;
      if (cu) tomTat.className = "warn";
    }
    loc.hidden = !tongVao;
    ve();
  }
  docLai.addEventListener("click", () => void busy(docLai, "Đang gửi…", async () => {
    loi.hidden = true;
    if (conDangDocNhom(b.id)) { loi.textContent = MSG_DANG_DOC; loi.hidden = false; return; } // đã ra lệnh vài phút trước: không gửi lệnh thứ hai (máy chủ chắc chắn trả 409)
    try {
      await api("POST", "/api/nhom-nick/cap-nhat", { botId: b.id });
      ghiDaRaLenhDocLai(b.id);
      toast("Đã ra lệnh cho bot đọc lại danh sách nhóm — chờ vài phút rồi mở lại hộp này");
    } catch (e) { loi.textContent = errMsg(e); loi.hidden = false; }
  }));
  void tai();
}

// ------------------------------------------------------------------ Lệnh
/** Một hộp ra lệnh cho MỘT bot: gõ lệnh bằng lời (luồng “Lệnh chữ”: AI soạn → xem trước → bạn bấm Phát, không có gì tự chạy) HOẶC chọn kịch bản có sẵn. */
export function hopLenh(b: Bot): void {
  const hop0 = moHop(`Lệnh cho ${b.name}`, "bot-lenh-hop", "bot-lenh");
  if (!hop0) return;
  const hop: Hop = hop0;
  const nameOf = (id: string): string => store.bots.get(id)?.name ?? id;
  const text = h("textarea", { rows: 4, placeholder: "Ví dụ: tìm bài về phần mềm kiến trúc trên Facebook rồi bình luận nhẹ nhàng 2 bài", title: "Gõ việc cần làm bằng tiếng Việt; Ctrl+Enter = Soạn", "aria-label": "Lệnh bằng lời", "data-testid": "bot-lenh-text" });
  const loi = h("div", { class: "err-box", hidden: true, "data-testid": "bot-lenh-loi" });
  const kq = h("div", { "data-testid": "bot-lenh-ket-qua" });
  const soan = h("button", { type: "button", class: "pri", title: "Gửi câu lệnh cho AI soạn thành lệnh chạy; chỉ xem trước, chưa chạy gì", "data-testid": "bot-lenh-soan" }, "Soạn");
  const chon = h("button", { type: "button", title: "Chọn một kịch bản đã có để chạy trên bot này (chưa chạy gì cho tới khi bạn bấm ▶ Chạy)", "data-testid": "bot-lenh-chon" }, "Chọn kịch bản có sẵn…");
  hop.than.append(
    h("p", { class: "small muted" }, "Gõ việc cần làm bằng lời — AI soạn thành lệnh, bạn xem trước rồi mới bấm Phát. Muốn chạy kịch bản đã có thì bấm “Chọn kịch bản có sẵn”."),
    h("label", { class: "f" }, h("span", {}, "Lệnh"), text), loi, kq);
  hop.chan.append(chon, soan, nutDong(hop));
  const bao = (c: string): void => { loi.textContent = c; loi.hidden = false; };
  chon.addEventListener("click", () => { hop.dong(); moHopChonKichBan([b.id]); });
  text.addEventListener("keydown", (e) => { if ((e.ctrlKey || e.metaKey) && e.key === "Enter") soan.click(); });

  function veKetQua(d: DraftResult, cauDaGo: string): void {
    clear(kq);
    const low = !!d.spec && d.doTinCay < LOW_CONFIDENCE;
    const card = h("div", { class: `bot-lenh-xem${low ? " lenh-low" : ""}`, "data-testid": "bot-lenh-xem" });
    card.append(h("h4", {}, d.spec ? "Xem trước" : "Chưa có kịch bản nào khớp lệnh này"));
    if (low) card.append(h("p", { class: "warn small", "data-testid": "bot-lenh-canh-bao" }, "AI không chắc, hãy kiểm tham số"));
    if (d.spec) {
      const spec = d.spec;
      const cau = h("p", { class: "wrap", "data-testid": "bot-lenh-cau" }, previewSentence(spec, nameOf));
      ganTenKbChu(cau, spec.bundleName, () => previewSentence(spec, nameOf, tenKbDaBiet));
      card.append(cau);
      if (spec.botIds.some((id) => id !== b.id)) card.append(h("p", { class: "warn small", "data-testid": "bot-lenh-nhieu-bot" }, "Lệnh này nhắc tới cả bot khác — kiểm danh sách bot ở câu trên trước khi Phát."));
      if (spec.mode === "live") card.append(h("p", { class: "small warn" }, "Chế độ chạy thật: bot sẽ làm THẬT (bước rủi ro cao vẫn dừng chờ duyệt)."));
    }
    card.append(h("p", { class: "small muted wrap", "data-testid": "bot-lenh-mo-ta" }, d.moTa));
    if (d.goiY) card.append(h("p", { class: `small wrap${d.spec ? " warn" : ""}`, "data-testid": "bot-lenh-goi-y" }, d.spec ? "Gợi ý: " : "", d.goiY));
    const phatLoi = h("div", { class: "err-box", hidden: true, "data-testid": "bot-lenh-phat-loi" });
    const phat = h("button", { type: "button", class: d.spec ? "pri" : "", disabled: !d.spec, title: d.spec ? "Phát lệnh đúng như bản xem trước (máy chủ kiểm tra lại, bot không đủ điều kiện sẽ bị bỏ qua)" : "Chưa có kịch bản khớp lệnh này để phát", "data-testid": "bot-lenh-phat" }, "Phát");
    const huy = h("button", { type: "button", title: "Bỏ bản xem trước, không phát gì", "data-testid": "bot-lenh-huy", onclick: () => clear(kq) }, "Huỷ");
    const hang = h("div", { class: "row end" });
    if (!d.spec) {
      const tao = h("button", { type: "button", class: "pri", title: "Tạo kịch bản mới: AI viết các bước theo đúng câu bạn vừa gõ; bạn xem, sửa rồi mới chạy (chưa chạy gì)", "data-testid": "bot-lenh-tao-kb" }, "Tạo kịch bản từ câu này");
      const yeuCauId = `lenh${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
      tao.addEventListener("click", () => void busy(tao, "Đang tạo…", async () => {
        phatLoi.hidden = true;
        try {
          const kb = await api<{ id: string }>("POST", "/api/kich-ban", { yeuCau: cauDaGo, yeuCauId });
          hop.dong();
          location.hash = `/kich-ban/${encodeURIComponent(kb.id)}`;
        } catch (e) { phatLoi.textContent = `Không tạo được kịch bản: ${errMsg(e)}`; phatLoi.hidden = false; }
      }));
      hang.append(tao);
      if (d.goiYKichBan?.length) card.append(h("div", { class: "small", "data-testid": "bot-lenh-kb-gan" }, h("p", {}, "Hoặc mở kịch bản có sẵn gần giống câu này:"),
        h("ul", {}, ...d.goiYKichBan.map((k) => h("li", {}, h("a", { href: `#/kich-ban/${encodeURIComponent(k.id)}`, title: "Mở kịch bản này để xem và chạy" }, k.ten))))));
    }
    hang.append(huy, phat);
    card.append(phatLoi, hang);
    kq.append(card);
    phat.addEventListener("click", () => void busy(phat, "Đang phát…", async () => {
      if (!d.spec) return;
      phatLoi.hidden = true;
      const spec: JobSpec = { ...d.spec, botIds: [...d.spec.botIds], params: { ...d.spec.params }, canary: { ...d.spec.canary } };
      try {
        const pv = await api<PreviewResult>("POST", "/api/jobs/preview", spec);
        const okIds = pv.runs.filter((r) => r.ok).map((r) => r.botId);
        if (!okIds.length) { phatLoi.textContent = `Không bot nào chạy được: ${pv.runs.map((r) => `${r.botName}: ${r.reason ?? "máy chủ từ chối"}`).join("; ")}`; phatLoi.hidden = false; return; }
        spec.botIds = spec.botIds.filter((id) => okIds.includes(id));
        if (spec.canary.botId && !spec.botIds.includes(spec.canary.botId)) delete spec.canary.botId;
        const job = await api<Job>("POST", "/api/jobs", spec);
        const boQua = pv.runs.filter((r) => !r.ok);
        toast(boQua.length ? `Đã phát lệnh cho ${okIds.length} bot; bỏ ${boQua.length} bot (${boQua.map((r) => r.botName).join(", ")})` : `Đã phát lệnh cho ${job.runs.length} bot`);
        hop.dong();
        location.hash = `/jobs/${encodeURIComponent(job.id)}`;
      } catch (e) { phatLoi.textContent = errMsg(e); phatLoi.hidden = false; }
    }));
  }

  soan.addEventListener("click", () => void busy(soan, "Đang soạn…", async () => {
    loi.hidden = true;
    const t = text.value.trim();
    if (!t) { bao("Chưa nhập lệnh"); return; }
    if (Array.from(t).length > MAX_LENH) { bao(`Lệnh quá dài (tối đa ${MAX_LENH.toLocaleString("vi-VN")} ký tự) — hãy rút gọn`); return; }
    clear(kq);
    try {
      const d = await api<DraftResult>("POST", "/api/jobs/draft", { text: t, botIds: [b.id] });
      if (!hop.wrap.isConnected) return;
      veKetQua(d, t);
    } catch (e) { if (hop.wrap.isConnected) bao(errMsg(e)); }
  }));
  text.focus();
}

// ------------------------------------------------------------------ Ghi chú (06/10/2026)
export type GhiChuTq = NonNullable<TongQuanBot["ghiChu"]>;
const KHOA_NHAP = "boss.ghiChuNhap:";
const khoNhap = (): Pick<Storage, "getItem" | "setItem" | "removeItem"> | undefined => { try { return window.sessionStorage; } catch { return undefined; } };

/**
 * Hộp "Ghi chú" riêng cho một bot: ô văn bản, đếm ký tự (vượt 2000 → khoá Lưu), Lưu / Xoá ghi chú / Đóng, Ctrl+Enter = Lưu, Esc đóng.
 * Lưu lỗi (mất mạng, máy chủ từ chối) → báo rõ ngay trong hộp, KHÔNG đóng hộp, giữ nguyên chữ đã gõ. Chữ chưa lưu còn được nhớ làm bản nháp
 * (sessionStorage, theo bot) để lỡ đóng hộp / F5 không mất. Chữ hiển thị luôn qua textContent / value — không innerHTML.
 * `khiLuu(ghiChu)` được gọi sau khi máy chủ xác nhận (null = đã xoá).
 */
export function hopGhiChu(b: Bot, hienTai: GhiChuTq | undefined, khiLuu: (g: GhiChuTq | null) => void): void {
  const hop = moHop(`Ghi chú — ${b.name}`, "bot-ghi-chu-hop", "ghi-chu-hop");
  if (!hop) return;
  const daLuu = hienTai?.noiDung ?? "";
  const o = h("textarea", { class: "ghi-chu-o", rows: 7, "data-testid": "ghi-chu-o", "aria-label": `Ghi chú cho ${b.name}`, "aria-describedby": "ghi-chu-dem", placeholder: "Ví dụ: nick này đang bị khoá nhóm A · tài khoản dùng cho FB nuôi nhóm…" });
  const nhapKey = KHOA_NHAP + b.id;
  let nhap: string | null = null;
  try { nhap = khoNhap()?.getItem(nhapKey) ?? null; } catch { nhap = null; }
  const coBanNhap = nhap !== null && nhap !== daLuu;
  o.value = coBanNhap ? nhap! : daLuu;
  const dem = h("span", { class: "small muted", id: "ghi-chu-dem", "data-testid": "ghi-chu-dem", "aria-live": "polite" });
  const loi = h("div", { class: "err-box", role: "alert", hidden: true, "data-testid": "ghi-chu-loi" });
  const luu = h("button", { type: "button", class: "pri", title: "Lưu ghi chú này cho bot (mọi thiết bị đều thấy)", "data-testid": "ghi-chu-luu" }, "Lưu");
  const xoa = h("button", { type: "button", class: "danger", disabled: !daLuu, title: daLuu ? "Xoá hẳn ghi chú của bot này" : "Bot này chưa có ghi chú", "data-testid": "ghi-chu-xoa" }, "Xoá ghi chú");
  const veDem = (): void => {
    const qua = !chuanHoaGhiChu(o.value).ok;
    dem.textContent = `${demKyTu(o.value.trim())}/${GHI_CHU_TOI_DA} ký tự`;
    dem.className = `small ${qua ? "err" : "muted"}`;
    luu.disabled = qua || luu.dataset.dang === "1";
    luu.title = qua ? `Ghi chú dài quá ${GHI_CHU_TOI_DA} ký tự — hãy rút gọn rồi lưu` : "Lưu ghi chú này cho bot (mọi thiết bị đều thấy)";
  };
  o.addEventListener("input", () => {
    veDem();
    loi.hidden = true;
    try { if (o.value === daLuu) khoNhap()?.removeItem(nhapKey); else khoNhap()?.setItem(nhapKey, o.value); } catch { /* không lưu nháp được: bỏ qua */ }
  });
  const meta = hienTai ? `Sửa lần cuối ${fmtTime(hienTai.capNhatLuc)}${hienTai.capNhatBoi ? ` bởi ${hienTai.capNhatBoi}` : ""}` : "Chưa có ghi chú";
  hop.than.append(
    h("p", { class: "small muted wrap", "data-testid": "ghi-chu-meta" }, meta),
    ...(coBanNhap ? [h("p", { class: "small warn", "data-testid": "ghi-chu-nhap" }, "Đã khôi phục bản nháp chưa lưu của bạn.")] : []),
    o, h("div", { class: "row between" }, dem), loi);

  /** Gửi lên máy chủ; thành công → đóng hộp. Lỗi → báo trong hộp, giữ chữ. */
  const gui = async (noiDung: string, nut: HTMLButtonElement, dangGui: string, xong: string): Promise<void> => {
    loi.hidden = true;
    luu.dataset.dang = "1";
    try {
      await busy(nut, dangGui, async () => {
        (nut === luu ? xoa : luu).disabled = true; // nút KIA khoá trong lúc gửi (nút đang bấm do busy() khoá — khoá trước busy() thì busy() bỏ qua)
        try {
          const r = await api<{ noiDung: string; capNhatLuc: string | null; capNhatBoi: string | null }>("PUT", `/api/bots/${encodeURIComponent(b.id)}/ghi-chu`, { noiDung });
          try { khoNhap()?.removeItem(nhapKey); } catch { /* bỏ qua */ }
          khiLuu(r.noiDung ? { noiDung: r.noiDung, capNhatLuc: r.capNhatLuc ?? new Date().toISOString(), capNhatBoi: r.capNhatBoi } : null);
          toast(xong);
          hop.dong();
        } catch (e) {
          if (hop.wrap.isConnected) { loi.textContent = `Chưa lưu được: ${errMsg(e)} — chữ bạn gõ vẫn còn đây, bấm Lưu để thử lại`; loi.hidden = false; }
        }
      });
    } finally {
      delete luu.dataset.dang;
      if (hop.wrap.isConnected) { xoa.disabled = !daLuu; veDem(); }
    }
  };
  luu.addEventListener("click", () => {
    const r = chuanHoaGhiChu(o.value);
    if (!r.ok) { loi.textContent = r.loi; loi.hidden = false; return; }
    void gui(r.noiDung, luu, "Đang lưu…", r.noiDung ? "Đã lưu ghi chú" : "Đã xoá ghi chú");
  });
  xoa.addEventListener("click", () => void (async () => {
    if (!(await confirmBox({ title: `Xoá ghi chú của ${b.name}?`, text: "Ghi chú sẽ mất hẳn trên mọi thiết bị.", okText: "Xoá ghi chú", okTitle: "Xoá hẳn ghi chú của bot này", danger: true }))) return;
    if (hop.wrap.isConnected) await gui("", xoa, "Đang xoá…", "Đã xoá ghi chú");
  })());
  o.addEventListener("keydown", (e) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); luu.click(); } });
  hop.chan.append(xoa, h("span", { class: "grow" }), nutDong(hop), luu);
  veDem();
  o.focus();
  o.setSelectionRange(o.value.length, o.value.length);
}
